import { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Typography,
  Snackbar as MUISnackbar,
  Alert,
  AlertTitle,
} from '@mui/material'

import { ReactComponent as Warning } from '../../../assets/icons/warning.svg'
import { ReactComponent as WarningCircle } from '../../../assets/icons/warning-circle.svg'

import styles from './styles'

const Snackbar = ({
  open,
  severity,
  title,
  text,
  code,
  fixed,
  autoHideDuration = 6000,
  bottomPosition = 0,
}) => {
  const [isOpen, setIsOpen] = useState(open)

  return (
    <MUISnackbar
      open={isOpen}
      onClose={() => setIsOpen(false)}
      autoHideDuration={fixed ? null : autoHideDuration}
      transitionDuration={400}
      sx={{
        ...styles.snackbar,
        bottom: bottomPosition,
        zIndex: 100000,
      }}
    >
      <Alert
        iconMapping={{
          info: <WarningCircle fontSize="inherit" />,
          warning: <Warning fontSize="inherit" />,
          error: <Warning fontSize="inherit" />,
        }}
        severity={severity}
        sx={styles.snackbarContent}
      >
        {Boolean(title) ? (
          <AlertTitle sx={styles.snackbarTitle}>{title}</AlertTitle>
        ) : null}
        <Typography sx={styles.snackbarTextContent}>
          {code ? (
            <>
              <strong>{code}</strong>
              <br />
            </>
          ) : null}
          {text}
        </Typography>
      </Alert>
    </MUISnackbar>
  )
}

Snackbar.propTypes = {
  open: PropTypes.bool,
  severity: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  code: PropTypes.string,
  fixed: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  bottomPosition: PropTypes.number,
}

export default Snackbar
